module.exports = __webpack_public_path__ + "static/img/prq3.79b6616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq3.jpg
// module id = F98o
// module chunks = 2